import { useSearchParams } from "react-router-dom";
import { useContentShowQuery } from "@/admin/entities/contents";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

/**
 * Feature-специфичные хуки для управления контентом
 * Комбинируют entity-логику с UI-специфичными потребностями
 */

/**
 * Основной хук для feature управления контентом
 * Предоставляет всю необходимую конфигурацию и логику для UI компонента
 */
export function useContentsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // Используем entity хук для загрузки данных единицы контента
  useContentShowQuery(id, id === null);

  return {
    // Конфигурация таблицы
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,

    // Трансформация данных
    getTableData,

    // Текстовые метки
    texts: getTextsConfig(),
  };
}
